import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelDynamic as _vModelDynamic, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["name", "id"]
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  key: 0,
  class: "cf-input__error"
}

import { useField } from 'vee-validate';
import { computed, ref } from 'vue';

type Props = {
  name: string;
  label: string;
  validate?: boolean;
};

export default /*@__PURE__*/_defineComponent({
  __name: 'InputField',
  props: {
    name: {},
    label: {},
    validate: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const isValidating = ref(false);
function blur() {
  isValidating.value = true;
}

const { value, errorMessage } = useField<string>(() => props.name);

const hasError = computed(() => {
  // If no error message, the field is valid
  if (!errorMessage.value) {
    return false;
  }

  // If form validate is true, validation should be shown
  if (props.validate) {
    return true;
  }

  // If field has been blurred with errors, validation should be shown
  if (isValidating.value) {
    return true;
  }

  // If none of the conditions apply, the field is valid.
  return false;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["cf-input", { 'cf-input--error': hasError.value }])
  }, [
    _withDirectives(_createElementVNode("input", _mergeProps({
      name: props.name,
      id: props.name,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
      class: { filled: _unref(value) }
    }, _ctx.$attrs, { onBlur: blur }), null, 16, _hoisted_1), [
      [_vModelDynamic, _unref(value)]
    ]),
    _createElementVNode("label", {
      for: props.name
    }, [
      _createElementVNode("span", null, _toDisplayString(props.label), 1)
    ], 8, _hoisted_2),
    (hasError.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(errorMessage)), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})